export default __webpack_public_path__ + "static/media/crypto-cover.4106adfc.jpg";